export default __webpack_public_path__ + "static/media/caseBg.84c54bd2.jpg";